import { render, staticRenderFns } from "./ModelInfoAndForm.vue?vue&type=template&id=2ce4d7d0"
import script from "./ModelInfoAndForm.vue?vue&type=script&lang=ts"
export * from "./ModelInfoAndForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports